import { useState, useEffect } from "react";
import { Tooltip } from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import grohe from "../../src/clientlogo/index_grohe_logo.jpg";
import americanStandard from "../../src/clientlogo/index_as_logo.gif";
import lixil from "../../src/clientlogo/lixil.png";
import { Link, useNavigate } from "react-router-dom";

const UserTopbar = ({ heading, sidebar }) => {
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [networkSpeed, setNetworkSpeed] = useState(null);
  const navigate = useNavigate();

  const clientLogos = [
    { src: grohe, alt: "Grohe", bg: "#111F39" },
    { src: americanStandard, alt: "American Standard", bg: "#fff" },
  ];

  const checkNetworkSpeed = async () => {
    const startTime = performance.now();
    try {
      const testUrl = "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js?cache=" + Math.random();
      const response = await fetch(testUrl, { cache: "no-store" });
      const blob = await response.blob();
      const speedMbps = (((blob.size / 1024) / ((performance.now() - startTime) / 1000)) / 1024 * 8).toFixed(2);
      setNetworkSpeed(!isFinite(speedMbps) || speedMbps <= 0 ? "N/A" : speedMbps);
    } catch {
      setNetworkSpeed("N/A");
    }
  };

  useEffect(() => {
    checkNetworkSpeed();
    const interval = setInterval(checkNetworkSpeed, 4000);
    return () => clearInterval(interval);
  }, []);

  const handleFullscreen = () => {
    const doc = window.document;
    if (!doc.fullscreenElement) {
      doc.documentElement.requestFullscreen?.();
      setIsFullscreen(true);
    } else {
      doc.exitFullscreen?.();
      setIsFullscreen(false);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  const isOffline = networkSpeed === "N/A" || networkSpeed === null;

  return (
    <div
      className={`fixed top-0 right-0 z-50 flex items-center justify-between px-6 h-16 bg-gray-900/60 backdrop-blur-md text-white border-b border-white/20 shadow-xl transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] ${
        sidebar ? "left-52" : "left-20"
      }`}
    >
      <div className="flex gap-4 items-center z-10 cursor-pointer" onClick={() => navigate("/user")}>
        {clientLogos.map((logo, index) => (
          <div
            key={index}
            className="w-20 h-12 flex items-center justify-center overflow-hidden border border-white/10"
            style={{ backgroundColor: logo.bg }}
          >
            <img src={logo.src} alt={logo.alt} className="w-full h-full object-contain p-1" />
          </div>
        ))}
      </div>

      <div className="absolute left-1/2 -translate-x-1/2 flex items-center gap-4 bg-white border border-white/20 px-6 py-2 rounded-lg backdrop-blur-sm shadow-inner">
        <img src={lixil} alt="LIXIL" className="w-12 h-7 object-contain" />
        <div className="w-[1px] h-4 bg-gray-500" />
        <h1 className="text-sm font-bold tracking-widest uppercase text-gray-800 whitespace-nowrap">
          {heading}
        </h1>
      </div>

      <div className="flex items-center gap-6 z-10">
        <div className="flex items-center gap-3 border-r border-white/10 pr-4">
          <div className="hidden sm:block text-right">
            <p className="text-sm font-bold text-white uppercase tracking-tighter leading-none">
              {localStorage.getItem("user_name")}
            </p>
            <p className={`text-[10px] font-black uppercase mt-1 tracking-widest ${isOffline ? "text-red-500" : "text-[#6fca86]"}`}>
              {isOffline ? "● Offline" : "● Online"}
            </p>
          </div>

          <div className="relative flex items-center gap-2">


            <button
              onClick={() => setShowProfileMenu(!showProfileMenu)}
              className="w-10 h-10 bg-[#ff7b00] border border-blue-400 rounded-full flex items-center justify-center shadow-lg hover:bg-[#ff7b00]/80 transition-all text-white"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
              </svg>
            </button>

            {showProfileMenu && (
              <div className="absolute top-12 right-0 w-48 bg-gray-800 border border-white/10 rounded-lg shadow-2xl py-2 z-50">
                <Link to="/user/change-password" title="Change Password"
                  className="block px-4 py-2 text-xs font-bold text-white hover:bg-white/10"
                >
                  CHANGE PASSWORD
                </Link>
                <button onClick={handleLogout}
                  className="w-full text-left px-4 py-2 text-xs font-bold text-red-400 hover:bg-red-500/10"
                >
                  LOGOUT
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="flex items-center gap-3">
          {/* <Tooltip title="Current Connection Speed" arrow>
            <div className={`flex items-center gap-2 px-3 py-1.5 rounded border ${isOffline ? "bg-red-500/10 border-red-500/50" : "bg-black border-[#ff7b00]/30"}`}>
              <div className={`w-1.5 h-1.5 rounded-full ${isOffline ? "bg-red-500" : "bg-emerald-500 animate-pulse shadow-[0_0_8px_#10b981]"}`} />
              <span className={`text-xs font-black font-mono ${isOffline ? "text-red-400" : "text-[#ff7b00]"}`}>
                {isOffline ? "0.00 Mbps" : `${networkSpeed} Mbps`}
              </span>
            </div>
          </Tooltip> */}
          
          <button onClick={handleFullscreen} className="text-gray-400 hover:text-white transition-colors">
            {isFullscreen ? <ExitToAppIcon fontSize="small" /> : <AspectRatioIcon fontSize="small" />}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserTopbar;